import { AnyObject } from '@movecloser/front-core'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const REGISTER_FORM_COMPONENT_KEY = 'RegisterFormComponent'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const defaultComponentConfig: AnyObject = {
  hasUserDeliveryAddressInput: true,
  isSubscribedToNews: true
}
